import * as yup from 'yup';

import { assertNestedOptionLeaf } from '~/core/shared/components/form/NestedSelect';
import { Fields } from '~/core/shared/types';

type FormFieldTypes = {
  type: any;
  key: string;
  label: any;
  options?: Fields.NestedSelect['options'];
  required: boolean;
  updated: string;
  value: any;
};

// TODO: deprecate this in favor of getValidationSchemaFromFormFieldBlock
export const generateSchema = (formFields: any): yup.AnyObjectSchema => {
  const shape: { [key: string]: yup.AnySchema } = {};

  formFields?.data?.data?.forEach((field: FormFieldTypes) => {
    let validator: yup.AnySchema;
    switch (field.type) {
      case 'text':
        // revert this after testing base fields only needs required when field is set
        validator = yup.string();
        break;
      case 'email':
        validator = yup.string().email('Invalid email');
        break;
      case 'number':
        validator = yup.number().nullable();
        break;
      case 'percentage':
        validator = yup
          .string()
          .nullable()
          .test('percentage', 'Must be between 0 and 100', (val) => {
            if (!val) return true;
            const n = Number(val);
            return !Number.isNaN(n) && n >= 0 && n <= 100;
          });
        break;
      case 'typeahead':
        validator = yup.array().of(yup.string()).nullable();
        break;
      case 'nested_select':
        validator = assertNestedOptionLeaf(
          yup.string().nullable(),
          field.options,
        );
        break;
      default:
        validator = yup.string().nullable();
    }

    if (field.required) {
      if (field.type === 'typeahead') {
        validator = validator.required().min(1, `${field.label} is required`);
      } else {
        validator = validator.required(`${field.label} is required`);
      }
    }

    shape[field.key] = validator;
  });

  return yup.object().shape(shape);
};
